import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const getHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const getMuestraEmailRecipients = async () => {
  const response = await axios.get(`${API_URL}/api/muestras-email-recipients`, {
    headers: getHeaders(),
  });
  return response.data;
};

export const createMuestraEmailRecipient = async ({ group, email }) => {
  const response = await axios.post(
    `${API_URL}/api/muestras-email-recipients`,
    { group, email },
    { headers: getHeaders() }
  );
  return response.data;
};

export const deleteMuestraEmailRecipient = async (id) => {
  const response = await axios.delete(
    `${API_URL}/api/muestras-email-recipients/${id}`,
    { headers: getHeaders() }
  );
  return response.data;
};
